export default __webpack_public_path__ + "static/blog-details-img-1-bef414dc298e39c35d1788978fc5c597.png";